import { when } from 'mobx';
import { once } from '../../js/utils';
import { MraidStore } from '../MraidStore';
import { FormatStateStore, FormatState } from '../FormatStateStore';
import { AnalyticsStore } from '../AnalyticsStore';
import { UserClickHandler } from './UserClickHandler';
import { logMessage } from 'common/js/sentry';
import { DisplayConfigType } from 'formats/display/lib/config';

interface MraidUnloadCallHandlerProps {
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;
  analyticsStore: AnalyticsStore;
  userClickHandler?: UserClickHandler;
  adContext: AdContext;
  formatConfig: DisplayConfigType;
}
// @TODO: separate load error and close on click handlers
export class MraidUnloadCallHandler {
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;
  analyticsStore: AnalyticsStore;
  userClickHandler?: UserClickHandler;
  adContext: AdContext;
  formatConfig: DisplayConfigType;
  constructor({
    mraidStore,
    formatStateStore,
    analyticsStore,
    userClickHandler,
    adContext,
    formatConfig
  }: MraidUnloadCallHandlerProps) {
    this.mraidStore = mraidStore;
    this.formatStateStore = formatStateStore;
    this.analyticsStore = analyticsStore;
    this.userClickHandler = userClickHandler;
    this.adContext = adContext;
    this.formatConfig = formatConfig;
    this.formatHasErrored = once(this.formatHasErrored);
    this.onUserClicked = once(this.onUserClicked);

    when(
      () =>
        this.formatStateStore.state === FormatState.AssetLoadingError &&
        this.mraidStore.isReady === true,
      () => this.formatHasErrored()
    );

    if (this.analyticsStore && this.userClickHandler) {
      when(
        () => {
          return (
            this.userClickHandler != null &&
            this.userClickHandler.hasClicked === true &&
            this.mraidStore.isReady === true &&
            !this.adContext.isUserAcquisition
          );
        },
        () => this.onUserClicked()
      );
    }
  }

  private formatHasErrored() {
    this.analyticsStore.sendAdsEventsTrack('loaded_error');
    this.analyticsStore.sendCreativeTrack('load_error');
    this.analyticsStore
      .waitUntilTracksAreSent()
      .then(() => this.mraidStore.triggerUnload());
  }

  protected onUserClicked() {
    this.analyticsStore.waitUntilTracksAreSent().then((trackSent: boolean) => {
      if (!trackSent) {
        logMessage('Close Ad before all track are sent');
      }

      // Use forceClose to bypass the clearCloseCallbackAfterClick no-op override on mraid.close.
      // Banner/MPU types are already excluded via MraidNoUnloadOnClickHandler (empty onUserClicked).
      this.mraidStore.forceClose();
    });
  }
}
